import { useForm } from 'react-hook-form';
import type { Property } from '../types';

type Props = {
  initial?: Property | null;
  onSubmit: (input: Partial<Property>) => Promise<void> | void;
  onCancel: () => void;
  submitLabel: string;
};

type FormShape = { name: string; propertyCode: string };

export const PropertyForm = ({ initial, onSubmit, onCancel, submitLabel }: Props) => {
  const { register, handleSubmit, formState } = useForm<FormShape>({
    defaultValues: {
      name: initial?.name ?? '',
      propertyCode: initial?.propertyCode ?? '',
    },
  });
  const submit = handleSubmit((data) =>
    onSubmit({ name: data.name, propertyCode: data.propertyCode || null }),
  );
  return (
    <form
      onSubmit={(e) => {
        void submit(e);
      }}
    >
      <div className="form-grid">
        <div className="field">
          <label>Name *</label>
          <input {...register('name', { required: true })} />
        </div>
        <div className="field">
          <label>Property code</label>
          <input {...register('propertyCode')} />
        </div>
      </div>
      <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 16 }}>
        <button type="button" onClick={onCancel}>
          Cancel
        </button>
        <button type="submit" className="primary" disabled={formState.isSubmitting}>
          {submitLabel}
        </button>
      </div>
    </form>
  );
};
